// src/pages/commercial/CommercialTemplatesPage.js
import React, { useEffect, useState } from 'react';
import CommercialLayout from '../../components/commercial/CommercialLayout';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';

export default function CommercialTemplatesPage() {
    const { user } = useAuth();
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const [category, setCategory] = useState('all');

    // Filter states
    const categories = [
        { id: 'all', label: 'Tout' },
        { id: 'email', label: '📧 Emails' },
        { id: 'script', label: '📞 Scripts' },
        { id: 'objection', label: '🛡️ Objections' },
        { id: 'other', label: '📝 Autres' }
    ];

    const [formData, setFormData] = useState({
        title: '',
        category: 'email',
        content: '',
        tags: ''
    });

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const res = await pb.collection('sales_templates').getFullList({
                sort: '-created'
            });
            setTemplates(res);
        } catch (err) {
            console.error("Error fetching sales_templates", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleCreate = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await pb.collection('sales_templates').create({
                ...formData,
                owner: user.id
            });
            setShowModal(false);
            setFormData({ title: '', category: 'email', content: '', tags: '' });
            fetchTemplates();
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la création du modèle. Vérifiez que la collection 'sales_templates' existe.");
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Supprimer ce modèle ?")) return;
        try {
            await pb.collection('sales_templates').delete(id);
            setTemplates(prev => prev.filter(t => t.id !== id));
        } catch (err) {
            alert("Erreur suppression");
        }
    };

    const handleCopy = (content) => {
        navigator.clipboard.writeText(content);
        alert("Copié dans le presse-papier !");
    };

    const filteredTemplates = templates.filter(t => category === 'all' || t.category === category);

    return (
        <CommercialLayout title="Bibliothèque de Modèles">
            <div className="commercial-page-wrapper">
                <style>{`
                .commercial-page-wrapper {
                    --admin-panel: var(--commercial-panel, #fff);
                    --admin-panel-2: var(--commercial-panel-2, #f9fafb);
                    --admin-border: var(--commercial-border, #e2e8f0);
                    --admin-text: var(--commercial-text, #0f172a);
                    --admin-muted: var(--commercial-muted, #64748b);
                    --admin-accent: var(--commercial-accent, #4f46e5);
                }

                .commercial-page-wrapper .btn-primary { 
                    display: inline-flex; align-items: center; gap: 10px;
                    padding: 10px 14px; border-radius: 10px;
                    background: linear-gradient(135deg, var(--admin-accent), rgba(79,70,229,0.85));
                    border: 1px solid rgba(79,70,229,0.6);
                    box-shadow: 0 6px 18px rgba(79,70,229,0.35);
                    color: white;
                    cursor: pointer;
                    transition: all 0.2s;
                    font-weight: 500;
                }
                .commercial-page-wrapper .btn-primary:hover { transform: translateY(-1px); filter: brightness(1.04); }
                
                .commercial-page-wrapper .template-filters {
                    display: flex; gap: 10px; margin-bottom: 24px; overflow-x: auto; padding-bottom: 4px;
                }
                .commercial-page-wrapper .filter-tab {
                    padding: 8px 16px; border-radius: 99px; cursor: pointer;
                    font-weight: 500; border: 1px solid var(--admin-border);
                    background: var(--admin-panel); color: var(--admin-muted);
                    white-space: nowrap; transition: all 0.2s;
                }
                .commercial-page-wrapper .filter-tab:hover {
                    background: var(--admin-panel-2);
                }
                .commercial-page-wrapper .filter-tab.active {
                    background: var(--admin-accent);
                    color: white;
                    border-color: var(--admin-accent);
                }

                .commercial-page-wrapper .templates-grid {
                    display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 20px;
                }
                .commercial-page-wrapper .template-card {
                    background: var(--admin-panel);
                    border: 1px solid var(--admin-border);
                    border-radius: 16px;
                    padding: 20px;
                    display: flex; flex-direction: column; gap: 12px;
                    transition: all 0.2s;
                    height: 100%;
                }
                .commercial-page-wrapper .template-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 10px 20px -5px rgba(0,0,0,0.05);
                }
                .commercial-page-wrapper .template-content-preview {
                    background: var(--admin-panel-2);
                    padding: 12px; border-radius: 8px;
                    font-size: 0.85rem; color: var(--admin-muted);
                    border: 1px solid var(--admin-border);
                    flex: 1; overflow: hidden;
                    display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical;
                    white-space: pre-wrap;
                }
                .commercial-page-wrapper .template-footer {
                    display: flex; gap: 8px; margin-top: auto;
                }
                .commercial-page-wrapper .btn-copy {
                    flex: 1; padding: 8px; border-radius: 8px; border: 1px solid var(--admin-accent);
                    background: transparent; color: var(--admin-accent); font-weight: 500; cursor: pointer;
                    display: flex; align-items: center; justify-content: center; gap: 6px;
                    transition: all 0.2s;
                }
                .commercial-page-wrapper .btn-copy:hover {
                    background: var(--admin-accent); color: white;
                }

                /* Modal */
                .commercial-page-wrapper .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1001; padding: 20px; backdrop-filter: blur(2px); }
                .commercial-page-wrapper .modal-content { background: var(--admin-panel); color: var(--admin-text); border: 1px solid var(--admin-border); border-radius: 16px; width: 100%; max-width: 600px; padding: 24px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); }
                .commercial-page-wrapper .form-group { margin-bottom: 16px; }
                .commercial-page-wrapper .form-group label { display: block; margin-bottom: 6px; font-weight: 500; font-size: 0.9rem; }
                .commercial-page-wrapper .form-control { width: 100%; padding: 10px; border-radius: 8px; border: 1px solid var(--admin-border); background: var(--admin-panel-2); color: var(--admin-text); font-size: 0.95rem; }

                `}</style>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <div>
                        <h1 style={{ margin: 0, fontSize: '1.8rem' }}>Templates</h1>
                        <p style={{ color: 'var(--admin-muted)', margin: '4px 0 0 0' }}>Gagnez du temps avec vos modèles</p>
                    </div>
                    <button className="btn-primary" onClick={() => setShowModal(true)}>
                        <span>+ Nouveau Modèle</span>
                    </button>
                </div>

                <div className="template-filters">
                    {categories.map(cat => (
                        <div
                            key={cat.id}
                            className={`filter-tab ${category === cat.id ? 'active' : ''}`}
                            onClick={() => setCategory(cat.id)}
                        >
                            {cat.label}
                        </div>
                    ))}
                </div>

                {loading ? (
                    <div style={{ padding: 40, textAlign: 'center', color: 'var(--admin-muted)' }}>Chargement...</div>
                ) : (
                    <div className="templates-grid">
                        {filteredTemplates.length === 0 ? (
                            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 40, color: 'var(--admin-muted)', border: '1px dashed var(--admin-border)', borderRadius: 16 }}>
                                Aucun modèle dans cette catégorie.
                            </div>
                        ) : (
                            filteredTemplates.map(tpl => (
                                <div key={tpl.id} className="template-card">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ fontWeight: 600, fontSize: '1.05rem' }}>{tpl.title}</div>
                                        <button onClick={() => handleDelete(tpl.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: 0.3 }}>✕</button>
                                    </div>
                                    <span style={{ fontSize: '0.8rem', color: 'var(--admin-muted)', background: 'var(--admin-panel-2)', padding: '2px 8px', borderRadius: 12, alignSelf: 'flex-start' }}>
                                        {categories.find(c => c.id === tpl.category)?.label || tpl.category}
                                    </span>
                                    <div className="template-content-preview">
                                        {tpl.content}
                                    </div>
                                    <div className="template-footer">
                                        <button className="btn-copy" onClick={() => handleCopy(tpl.content)}>
                                            <span>📋</span> Copier
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}

                {/* Modal Create */}
                {showModal && (
                    <div className="modal-overlay" onClick={() => setShowModal(false)}>
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <h2 style={{ marginTop: 0, marginBottom: 20 }}>Créer un nouveau modèle</h2>
                            <form onSubmit={handleCreate}>
                                <div className="form-group">
                                    <label>Titre</label>
                                    <input required type="text" className="form-control" value={formData.title} onChange={e => setFormData({ ...formData, title: e.target.value })} placeholder="Ex: Relancer Prospect J+3" />
                                </div>
                                <div className="form-group">
                                    <label>Catégorie</label>
                                    <select className="form-control" value={formData.category} onChange={e => setFormData({ ...formData, category: e.target.value })}>
                                        {categories.filter(c => c.id !== 'all').map(c => (
                                            <option key={c.id} value={c.id}>{c.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Contenu du modèle</label>
                                    <textarea required className="form-control" rows={10} value={formData.content} onChange={e => setFormData({ ...formData, content: e.target.value })} placeholder="Bonjour [Nom], ..." />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
                                    <button type="button" onClick={() => setShowModal(false)} style={{ background: 'transparent', border: '1px solid var(--admin-border)', color: 'var(--admin-text)', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}>Annuler</button>
                                    <button type="submit" disabled={saving} className="btn-primary" style={{ border: 'none' }}>
                                        {saving ? '...' : 'Enregistrer'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </CommercialLayout>
    );
}
